import React, { useEffect, useState } from 'react';
import { Form } from "react-bootstrap";
// import { MdOutlineClear } from "react-icons/md";
import { TiDelete } from "react-icons/ti";
import { RxCross2 } from "react-icons/rx";
import Auth from '../../../Utilities/Auth';

function CommonSearch({ preFilterData = [], setFilteredDataState, propertyForMatch = [], isTitle = true, margin = "mb-2", title = "Search", placeHolder = "placeHolder", id = "search" }) {
    const [searchKey, setSearchKey] = useState("")
    const user_detail = JSON.parse(Auth.header().userdetail)


    useEffect(() => {
        searchOnSubmit()
    }, [searchKey, preFilterData])

    // search on submit
    const searchOnSubmit = () => {
        let searchedData = []

        searchKey.length != 0 && propertyForMatch.length != 0 && preFilterData.length != 0 && preFilterData.filter(singleData => {
            for (let prop of propertyForMatch) {
                let stringPropToarr = prop.split(".")
                if (stringPropToarr.length == 1) {
                    if ((singleData[stringPropToarr[0]] || "").toString().toLowerCase().includes(searchKey.toLowerCase())) {
                        return singleData
                    }
                } else if (stringPropToarr.length == 2) {
                    if (singleData[stringPropToarr[0]] != null ? singleData[stringPropToarr[0]][stringPropToarr[1]].toString().toLowerCase().includes(searchKey.toLowerCase()) : true == false) {
                        return singleData
                    }
                } else if (stringPropToarr.length == 3) {
                    if (singleData[stringPropToarr[0]] != null ? singleData[stringPropToarr[0]][stringPropToarr[1]][stringPropToarr[2]].toString().toLowerCase().includes(searchKey.toLowerCase()) : true == false) {
                        return singleData
                    }
                }

            }

        }).filter(singleData => {
            searchedData.push(singleData)
        })
        setFilteredDataState(searchKey.length != 0 ? searchedData : preFilterData)

    }

    return (
        <>
            {user_detail?.is_admin == "1" && <Form className='w-100' onSubmit={e => {
                e.preventDefault()
                searchOnSubmit()
            }}>
                <Form.Group className={margin} controlId="formBasicEmail">
                    {isTitle == true && <Form.Label>{title}</Form.Label>}
                    <span style={{ position: "relative", width: "100%", display: "block" }}>
                        <Form.Control id={id} className='w-100' onChange={e => {
                            let typedData = e.target.value || ""
                            setSearchKey(typedData)
                        }} type="text" placeholder={placeHolder} />

                        <RxCross2 onClick={e => {
                            setSearchKey("")
                            document.getElementById(id).value = ""
                        }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "20px", cursor: "pointer" }} className=" text-danger" />
                    </span>
                </Form.Group>
            </Form>}
        </>
    );
}

export default CommonSearch;